// Shrinks a phone photo before upload: a 12 MP JPEG is 4-8 MB, and the shop's
// connection is often one bar. Never upscales. If the image cannot be decoded
// (e.g. HEIC on Chrome) the original file is returned untouched and the server
// takes it as-is.

function jpgName(name) {
  const base = (name || 'photo').replace(/\.[^./\\]+$/, '');
  return `${base || 'photo'}.jpg`;
}

async function decode(file) {
  try {
    // Respect EXIF rotation so portrait shots are not saved sideways.
    return await createImageBitmap(file, { imageOrientation: 'from-image' });
  } catch (e) {
    return createImageBitmap(file);
  }
}

export async function downscaleImage(file, { maxEdge = 2000, quality = 0.85 } = {}) {
  const original = { blob: file, filename: file.name };
  try {
    if (typeof createImageBitmap !== 'function') return original;
    const bitmap = await decode(file);
    const { width, height } = bitmap;
    const scale = Math.min(1, maxEdge / Math.max(width, height));
    const w = Math.round(width * scale);
    const h = Math.round(height * scale);

    const canvas = document.createElement('canvas');
    canvas.width = w;
    canvas.height = h;
    const ctx = canvas.getContext('2d');
    // JPEG has no alpha: without this a transparent PNG would turn black.
    ctx.fillStyle = '#fff';
    ctx.fillRect(0, 0, w, h);
    ctx.drawImage(bitmap, 0, 0, w, h);
    if (typeof bitmap.close === 'function') bitmap.close();

    const blob = await new Promise((resolve) => canvas.toBlob(resolve, 'image/jpeg', quality));
    if (!blob) return original;
    // Re-encoding an already small image can grow it; keep the original then.
    if (scale === 1 && blob.size >= file.size) return original;
    return { blob, filename: jpgName(file.name) };
  } catch (e) {
    return original;
  }
}

export default downscaleImage;
